export enum ServicesEnum {
  GID_CRUD = "gid-crud",
  ORDER_INTAKE_FORMS_API = "order-intake-forms-api",
}
